module.exports = __webpack_public_path__ + "img/hazardEquip50.731171eb.jpg";